import { render } from "./InsurersPage.vue?vue&type=template&id=a4f279aa"
import script from "./InsurersPage.vue?vue&type=script&lang=js"
export * from "./InsurersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__